export default __webpack_public_path__ + "static/media/preview-2.0f1204f3.jpg";